import React from 'react';
import { ConfigProvider } from 'antd';
import { ThemeConfig } from 'antd/es/config-provider/context';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';

import './index.css';

import './i18n';

const basicTheme: ThemeConfig = {
  token: {
    borderRadius: 6,
    fontSize: 14,
    colorPrimary: 'black',
    fontFamily: 'Lato, Regular',
  },
  components: {
    Table: {},
    Select: {
      controlItemBgActive: '#f2f8fe',
    },
  },
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ConfigProvider theme={basicTheme}>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
